<template>
	<v-container fluid class="pa-4">
		<v-card class="background-2 round-card">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3 mb-0">Programma Audit annuale</p>
				<v-spacer></v-spacer>
				<v-btn icon @click="$refs.calendar.prev()"><v-icon>mdi-chevron-left</v-icon></v-btn>
				<span class="mx-2 text-subtitle-1">{{ title }}</span>
				<v-btn icon @click="$refs.calendar.next()"><v-icon>mdi-chevron-right</v-icon></v-btn>
				<v-btn text small class="ml-3" @click="focus = ''">Oggi</v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pa-3">
				<div class="mb-3">
					<v-chip x-small color="#3f51b5" dark label class="mr-1">Audit pianificato</v-chip>
					<v-chip x-small color="#4caf50" dark label class="mr-1">Audit eseguito</v-chip>
					<v-chip x-small color="#9c27b0" dark label class="mr-1">Riesame Direzione</v-chip>
				</div>
				<v-sheet height="600">
					<v-calendar ref="calendar" v-model="focus" type="month" locale="it" :events="events"
						:event-color="e => e.color" @click:event="openEvent" @click:date="viewDay"></v-calendar>
				</v-sheet>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'ComplianceAuditProgram',
	data() {
		return {
			focus: '',
			title: '',
			events: []
		}
	},
	created() { this.load() },
	mounted() { this.$nextTick(() => { if (this.$refs.calendar) this.title = this.$refs.calendar.title }) },
	watch: {
		focus() { this.$nextTick(() => { if (this.$refs.calendar) this.title = this.$refs.calendar.title }) }
	},
	methods: {
		extract(resp) {
			const d = resp.data.data
			return Array.isArray(d) ? d : (d && d.data ? d.data : [])
		},
		load() {
			this.events = []
			const body = { pagination: { rowsPerPage: 500, page: 1, sortBy: ['planned_date'], sortDesc: [false] } }
			this.axios.post('complianceaudits-filters', body).then(r => {
				this.extract(r).forEach(a => {
					if (a.planned_date) this.events.push(this.event(a.executed_date ? '#4caf50' : '#3f51b5', (a.code ? a.code + ' · ' : '') + a.title, a.executed_date || a.planned_date, 'complianceaudits-show', a.id))
				})
			}, () => {})
			const rbody = { pagination: { rowsPerPage: 500, page: 1, sortBy: ['review_date'], sortDesc: [false] } }
			this.axios.post('compliancereviews-filters', rbody).then(r => {
				this.extract(r).forEach(rv => {
					if (rv.review_date) this.events.push(this.event('#9c27b0', (rv.code ? rv.code + ' · ' : '') + rv.title, rv.review_date, 'compliancereviews-show', rv.id))
				})
			}, () => {})
		},
		// v-calendar accetta solo 'YYYY-MM-DD'; l'API può restituire un timestamp
		// ISO UTC (es. 2026-06-01T22:00:00Z) → normalizzo alla data LOCALE per
		// evitare crash e lo sfasamento di un giorno dovuto al fuso.
		toCalDate(d) {
			if (!d) return null
			if (typeof d === 'string' && d.length === 10) return d
			const dt = new Date(d)
			if (isNaN(dt.getTime())) return typeof d === 'string' ? d.slice(0, 10) : null
			const m = String(dt.getMonth() + 1).padStart(2, '0')
			const day = String(dt.getDate()).padStart(2, '0')
			return `${dt.getFullYear()}-${m}-${day}`
		},
		event(color, name, date, route, id) {
			const d = this.toCalDate(date)
			return { name, start: d, end: d, color, route, refId: id }
		},
		openEvent({ event }) {
			if (event.route) this.$router.push({ name: event.route, params: { id: event.refId } })
		},
		viewDay() {}
	}
}
</script>
